// Insert item's current message into message box
function currentMessage(id){
  var msg = CartJS.cart.items[id].properties['Message on Card'];
  var textareaid = "message" + id;
  document.querySelector("textarea[id*='"+textareaid+"']").value = msg;
}

function countTextCharMsg(msgid){
  var length = document.querySelector("textarea[id*='"+msgid+"']").value.length;
  var msgcharcountid = "message-char-count" + msgid.replace("message", "")
  document.querySelector("p[id*='"+msgcharcountid+"']").innerHTML = length + "/250 characters";
}

// Store current message box index
var divid = "";

function closePopup(){
  $(".editMsgBg").css({
    "opacity": "0",
    "visibility": "hidden"
  })
  $(divid).css("display", "none");
}

function deepEqual(obj1, obj2){
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length){
    return false;
  }

  for (const key of keys1){
    const val1 = obj1[key];
    const val2 = obj2[key];
    const areObjects = typeof val1 === 'object' && typeof val2 === 'object';

    if(areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2){
      return false;
    }
  }

  return true;
}

$(window).load(function() {

  // Button to toggle message box and insert current message
  $(".edit-tm").click(function() {
    var id = $(this).parents(".line-item-props").attr('id').slice(-1);
    currentMessage(Number(id));
    divid = "#div" + id;
    $(".editMsgBg").css({
      "opacity": "1",
      "visibility": "visible"
    });
    $(divid).css("display", "block");
  });

  // Close and hide all popup elements
  $(".editMsgBg, .closeEdit").click(function(){
    closePopup();
  });

  // Save changes button, update Message on Card of item
  $("button[id*='save']").click(async function() {
    const index = $(this).attr('id').replace("save", "");
    const { properties, quantity, variant_id } = CartJS.cart.items[index];
    const change_item = JSON.parse(JSON.stringify({
      variant_id,
      quantity,
      properties,
    }))

    const cart = await fetch('/cart.js').then(result => result.json())
    const curr_cart_items = cart.items.map(item => {
      const {properties, quantity, variant_id} = item
      return {
        properties,
        quantity,
        variant_id
      }
    })

    let change_index = -1
    curr_cart_items.forEach((item, index) => {
      if (deepEqual(item, change_item)){
        change_index = index
      }
    })

    properties['Message on Card'] = $("textarea[id*='message"+index+"']").val();
    const cart_length = CartJS.cart.items.length
    if(change_index >= 0){
      CartJS.updateItem(Number(change_index)+1, quantity, properties);
    } else {
      window.location.reload()
    }

    closePopup();

    setTimeout(()=>{
      if (cart_length != curr_cart_items.length){
        window.location.reload()
      }
    }, 2000)

  });
})
